import { fontStyleToCss } from '@/lib/fontStyle';
import type { DepartureStation as StationData } from '@/store/transforms';
import { DepartureLine } from '@/widgets/DepartureWidget/DepartureLine';
import { DEPARTURE_FONT_SIZE, type DepartureFonts } from '@/widgets/DepartureWidget/options';

/**
 * One stop: its name, then a row of `DepartureLine`s. Port of
 * `departure/departureStation.vue`.
 *
 * `min-width: 20%` is what makes the board wrap into at most five stations per row — it is a
 * legacy scoped-SCSS rule with no Tailwind equivalent (`min-w-1/5` is not a utility), so it
 * stays an inline style.
 */

export type DepartureStationProps = {
  station: StationData;
  fonts: DepartureFonts;
};

export function DepartureStation({ station, fonts }: DepartureStationProps) {
  const stationStyle = fontStyleToCss(fonts.station, { fontSize: DEPARTURE_FONT_SIZE });

  return (
    <div className="flex flex-col text-center p-2 stationContainer" style={{ minWidth: '20%' }}>
      <p className="stationLabel" style={stationStyle}>
        {station.name}
      </p>
      <div className="flex flex-row justify-center">
        {station.transports.map((line, index) => (
          <DepartureLine key={index} line={line} fonts={fonts} />
        ))}
      </div>
    </div>
  );
}
